import React from "react";
import { Box, List, ListItem, Text } from "@chakra-ui/react";

const SnapTradeHowItWorks: React.FC = () => {
  return (
    <Box w="full">
      <Text fontWeight={600} mb="6px">How it works</Text>
      <List spacing={1} styleType="decimal" pl="18px">
        <ListItem>Select “Connect” below</ListItem>
        <ListItem>Authenticate with your broker in a secure window</ListItem>
        <ListItem>Choose the accounts to sync; we’ll import your data</ListItem>
        <ListItem>We will also update throughout the day as new data is available</ListItem>
      </List>
    </Box>
  );
};

export default SnapTradeHowItWorks;


